const map = {
	"./about/about-card/index.scss": "../css/pages/about/about-card/index.scss",
	"./about/about-history/index.scss": "../css/pages/about/about-history/index.scss",
	"./about/about-slider/index.scss": "../css/pages/about/about-slider/index.scss",
	"./about/about/index.scss": "../css/pages/about/about/index.scss",
	"./about/biography/index.scss": "../css/pages/about/biography/index.scss",
	"./about/chairman-management/index.scss": "../css/pages/about/chairman-management/index.scss",
	"./about/company-management/index.scss": "../css/pages/about/company-management/index.scss",
	"./about/interprograms/index.scss": "../css/pages/about/interprograms/index.scss",
	"./about/intra-corporate-programs/index.scss": "../css/pages/about/intra-corporate-programs/index.scss",
	"./about/management/index.scss": "../css/pages/about/management/index.scss",
	"./about/managepolitic/index.scss": "../css/pages/about/managepolitic/index.scss",
	"./about/personnel-management/index.scss": "../css/pages/about/personnel-management/index.scss",
	"./about/vacancy-about/index.scss": "../css/pages/about/vacancy-about/index.scss",
	"./about/vacancy/index.scss": "../css/pages/about/vacancy/index.scss",
	"./about/vacancy/vacancy-about.scss": "../css/pages/about/vacancy/vacancy-about.scss",
	"./about/vacancy/vacancy-details.scss": "../css/pages/about/vacancy/vacancy-details.scss",
	"./contacts/index.scss": "../css/pages/contacts/index.scss",
	"./error/index.scss": "../css/pages/error/index.scss",
	"./hotline/index.scss": "../css/pages/hotline/index.scss",
	"./lego/index.scss": "../css/pages/lego/index.scss",
	"./main-page/main-page.scss": "../css/pages/main-page/main-page.scss",
	"./photo-gallery/photo-gallery.scss": "../css/pages/photo-gallery/photo-gallery.scss",
	"./pressoffice/news/index.scss": "../css/pages/pressoffice/news/index.scss",
	"./pressoffice/newspaper/index.scss": "../css/pages/pressoffice/newspaper/index.scss",
	"./pressreleases/index.scss": "../css/pages/pressreleases/index.scss",
	"./production/index.scss": "../css/pages/production/index.scss",
	"./production/product-extraction/index.scss": "../css/pages/production/product-extraction/index.scss",
	"./production/production-list/index.scss": "../css/pages/production/production-list/index.scss",
	"./production/production-map/index.scss": "../css/pages/production/production-map/index.scss",
	"./projects/index.scss": "../css/pages/projects/index.scss",
	"./search/index.scss": "../css/pages/search/index.scss",
	"./shareholders/board-directors/index.scss": "../css/pages/shareholders/board-directors/index.scss",
	"./shareholders/capital-structure/index.scss": "../css/pages/shareholders/capital-structure/index.scss",
	"./shareholders/corporate-governance/index.scss": "../css/pages/shareholders/corporate-governance/index.scss",
	"./shareholders/dividends/index.scss": "../css/pages/shareholders/dividends/index.scss",
	"./shareholders/financial_statements.scss": "../css/pages/shareholders/financial_statements.scss",
	"./shareholders/index/index.scss": "../css/pages/shareholders/index/index.scss",
	"./shareholders/information-disclosure-card/index.scss": "../css/pages/shareholders/information-disclosure-card/index.scss",
	"./shareholders/information-disclosure/information-disclosure-detail.scss": "../css/pages/shareholders/information-disclosure/information-disclosure-detail.scss",
	"./shareholders/information-disclosure/information-disclosure-info.scss": "../css/pages/shareholders/information-disclosure/information-disclosure-info.scss",
	"./shareholders/information_disclosure/index.scss": "../css/pages/shareholders/information_disclosure/index.scss",
	"./shareholders/insiders/index.scss": "../css/pages/shareholders/insiders/index.scss",
	"./shareholders/internal_documents/index.scss": "../css/pages/shareholders/internal_documents/index.scss",
	"./shareholders/investor-calendar/index.scss": "../css/pages/shareholders/investor-calendar/index.scss",
	"./shareholders/registrar/index.scss": "../css/pages/shareholders/registrar/index.scss",
	"./shareholders/scheme/index.scss": "../css/pages/shareholders/scheme/index.scss",
	"./shareholders/shareholders-analytics/index.scss": "../css/pages/shareholders/shareholders-analytics/index.scss",
	"./shareholders/shareholders-contact/index.scss": "../css/pages/shareholders/shareholders-contact/index.scss",
	"./shareholders/shareholders-content/index.scss": "../css/pages/shareholders/shareholders-content/index.scss",
	"./shareholders/shareholders-menu/index.scss": "../css/pages/shareholders/shareholders-menu/index.scss",
	"./shareholders/shareholders-requisites/index.scss": "../css/pages/shareholders/shareholders-requisites/index.scss",
	"./typical-page/index.scss": "../css/pages/typical-page/index.scss",
	"./video/index.scss": "../css/pages/video/index.scss"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../css/pages sync recursive \\.scss$";